export enum GenericWidgetDataActions {
  getGenericWidgetData = '[GenericWidgetData]: fetch one',
  loadGenericWidgetDataSuccess = '[GenericWidgetData]: load one: success',
  getGenericWidgetDataSuccess = '[GenericWidgetData]: fetch one: success',
  getGenericWidgetDataFailed = '[GenericWidgetData]: fetch one: failed',
  toggleItemSelected = '[GenericWidgetData]: toggle item selected',
  toggleAllItemsSelected = '[GenericWidgetData]: toggle all items selected'
}
